/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Queue_CountInputs */

const en_tables_users_queue_count = /** @type {(inputs: Tables_Users_Queue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Count`)
};

const de_tables_users_queue_count = /** @type {(inputs: Tables_Users_Queue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Queues`)
};

/**
* | output |
* | --- |
* | "Queue Count" |
*
* @param {Tables_Users_Queue_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_queue_count = /** @type {((inputs?: Tables_Users_Queue_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Queue_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_queue_count(inputs)
	return de_tables_users_queue_count(inputs)
});